import { gql } from '@apollo/client';

export default gql`
  query getPaymentLink($linkId: String!) {
    getPaymentLink(linkId: $linkId)
  }
`;
